<div class="flex w-full min-h-full justify-center ">
    <div class="flex h-auto flex-col items-center pt-10 px-2 gap-8 w-full md:w-[650px] lg:px-0">
        <div class="text-4xl text-pet-adm-color-1 font-bold w-full text-center">
            Historial de Citas
        </div>
        <!--------------------------------------------------------------------->
        <div class="text-center text-xl text-semibold text-pet-adm-color-1">
            ¡Bienvenido al historial de citas de {{userSession.nombreVeterinaria}}! Aquí puede acceder a un registro completo de las citas que ha tenido asignadas.
            Esto le proporcionará una visión general de su agenda pasada y le ayudará a mantenerse organizado en su práctica veterinaria.
        </div>
        <!--------------------------------------------------------------------->
        <div class="flex gap-3 w-full flex-wrap-reverse justify-center md:flex-nowrap">
            <div class="relative mb-6 w-full">
                <div class="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                    <mat-icon class="text-[#7A7A7A]">search</mat-icon>
                </div>
                <input type="text" id="input-group-1" (input)="searchEvt($event)"
                    class="bg-[#F4F5F4] shadow-md shadow-slate-500 h-10 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5 placeholder-gray-600"
                    placeholder="Buscar por tipo de consulta" />
            </div>

            <select (change)="orderByDate($event.target.value)" 
            class="w-auto bg-gray-50 h-10 border-2 border-pet-color-text-1 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-pet-color-text-1 block  p-2.5 px-3">
            <option selected value ='asc'>Fecha Ascendente</option>
            <option value='desc'>Fecha Descendente</option>
            </select>
        </div>
        <!--------------------------------------------------------------------->
        <!--lista de citas-->
        <div class="flex flex-col gap-4 w-full h-auto items-center pb-16">
            <ng-container *ngFor="let item of consultas">
                <app-appointment *ngIf="item.showComponent" [consulta]="item">
                </app-appointment>
            </ng-container>
        </div>

    </div>
</div>